import React, { useState, useEffect } from 'react';
import { supabase } from '../services/supabaseClient'; // Ajusta la ruta según tu estructura
import { MdSchool, MdOnlinePrediction, MdLocationOn, MdBusiness, MdAccessTime } from 'react-icons/md';
import { FaWhatsapp, FaClock, FaCalendarAlt, FaUsers, FaGraduationCap, FaSearch, FaInfoCircle, FaStar, FaTag, FaFire, FaBolt, FaCheckCircle, FaTimes, FaDownload, FaEye, FaEyeSlash, FaFileDownload, FaBuilding } from 'react-icons/fa';
const CourseCatalog = ({ user }) => {
    const [courses, setCourses] = useState([]);
    const [filteredCourses, setFilteredCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [selectedModality, setSelectedModality] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [priceRange, setPriceRange] = useState('all');
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showRequestModal, setShowRequestModal] = useState(false);
    const [requestingCourse, setRequestingCourse] = useState(null);
    const [categories, setCategories] = useState([]);
    const [submittingRequest, setSubmittingRequest] = useState(false);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});

    // Formulario de solicitud
    const [requestForm, setRequestForm] = useState({
        name: '',
        email: '',
        phone: ''
    });

    // Función para cargar cursos desde Supabase
    const loadCourses = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const { data, error } = await supabase
                .from('courses')
                .select('*')
                .eq('status', 'available') // Solo cursos disponibles
                .order('created_at', { ascending: false });

            if (error) {
                throw error;
            }

            // Procesar los datos para que coincidan con el formato esperado
            const processedCourses = data.map(course => ({
                ...course,
                // Asegurar que los campos necesarios existan
                imageUrl: course.image_url || getDefaultImage(course.category),
                company_logo_url: course.company_logo_url || null,
                brochure_url: course.brochure_url || null,
                instructor_title: course.instructor_title || 'Especialista certificado OECE',
                highlights: course.highlights ? course.highlights.split(',') : [
                    'Material actualizado',
                    'Soporte técnico',
                ],
                level: course.level || 'Intermedio',
                isActive: course.status === 'available',
                isHot: course.discount_percentage > 20,
                isBestseller: course.current_students > (course.max_students * 0.7),
                // Asegurar que los números sean correctos
                regular_price: parseFloat(course.regular_price) || 0,
                discounted_price: parseFloat(course.discounted_price) || parseFloat(course.regular_price),
                discount_percentage: parseFloat(course.discount_percentage) || 0,
                current_students: parseInt(course.current_students) || 0,
                max_students: parseInt(course.max_students) || 30
            }));

            setCourses(processedCourses);
            
            // Extraer categorías únicas
            const uniqueCategories = [...new Set(processedCourses.map(course => course.category))];
            setCategories(uniqueCategories);
            
        } catch (error) {
            console.error('Error loading courses:', error);
            setError(`Error al cargar cursos: ${error.message}`);
            setCourses([]);
        } finally {
            setLoading(false);
        }
    };

    // Función auxiliar para imágenes por defecto
    const getDefaultImage = (category) => {
        const categoryImages = {
            'Contratación': 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=200&fit=crop&crop=center&q=80',
            'Legal': 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&h=200&fit=crop&crop=center&q=80',
            'Gestión': 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=200&fit=crop&crop=center&q=80',
            'Finanzas': 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=200&fit=crop&crop=center&q=80',
            'Administración': 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=200&fit=crop&crop=center&q=80'
        };
        return categoryImages[category] || 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=200&fit=crop&crop=center&q=80';
    };
    const toggleDescription = (courseId) => {
        setExpandedDescriptions(prev => ({
            ...prev,
            [courseId]: !prev[courseId]
        }));
    };
    // useEffect para cargar cursos al montar el componente
    useEffect(() => {
        loadCourses();
    }, []);

    useEffect(() => {
        filterCourses();
    }, [courses, selectedCategory, selectedModality, searchTerm, priceRange]);

    const filterCourses = () => {
        let filtered = [...courses];

        if (searchTerm) {
            filtered = filtered.filter(course =>
                course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                course.instructor.toLowerCase().includes(searchTerm.toLowerCase()) ||
                course.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
                course.description.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        if (selectedCategory !== 'all') {
            filtered = filtered.filter(course => course.category === selectedCategory);
        }

        if (selectedModality !== 'all') {
            filtered = filtered.filter(course => course.modality.toLowerCase() === selectedModality);
        }

        if (priceRange !== 'all') {
            filtered = filtered.filter(course => {
                const price = parseFloat(course.discounted_price || course.regular_price);
                switch (priceRange) {
                    case 'under_300':
                        return price < 300;
                    case '300_500':
                        return price >= 300 && price <= 500;
                    case 'over_500':
                        return price > 500;
                    default:
                        return true;
                }
            });
        }

        setFilteredCourses(filtered);
    };
const handleRequestInfo = (course) => {
    setRequestingCourse(course);
    
    // Pre-llenar datos si el usuario está logueado
    if (user) {
        setRequestForm({
            name: user.name || user.full_name || '',
            email: user.email || '',
            phone: user.phone || ''
        });
    } else {
        setRequestForm({
            name: '',
            email: '',
            phone: ''
        });
    }
    
    setShowRequestModal(true);
    // Prevenir scroll del body
    document.body.style.overflow = 'hidden';
};

    const closeRequestModal = () => {
        setShowRequestModal(false);
        setRequestingCourse(null);
        // Restaurar scroll del body
        document.body.style.overflow = 'unset';
    };
const handleSubmitRequest = async () => {
    // Validación básica
    if (!requestForm.name || !requestForm.email || !requestForm.phone) {
        alert('Por favor completa los campos obligatorios: nombre, email y teléfono');
        return;
    }

    // Validación de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(requestForm.email)) {
        alert('Por favor ingresa un email válido');
        return;
    }
    
    try {
        setSubmittingRequest(true);
        
        // Primero verificar si ya existe una solicitud para este curso y email
        const { data: existingRequest, error: checkError } = await supabase
            .from('course_requests')
            .select('id')
            .eq('email', requestForm.email.trim())
            .eq('course_id', requestingCourse.id)
            .single();

        if (checkError && checkError.code !== 'PGRST116') {
            // PGRST116 significa "no rows returned", que es lo que esperamos
            throw checkError;
        }

        if (existingRequest) {
            alert('⚠️ Ya has solicitado información para este curso anteriormente. Si tienes dudas adicionales, contacta directamente con nosotros.');
            closeRequestModal();
            return;
        }
        
        // Guardar solicitud en Supabase
        const { data, error } = await supabase
            .from('course_requests')
            .insert([
                {
                    course_id: requestingCourse.id,
                    course_title: requestingCourse.title,
                    name: requestForm.name.trim(),
                    email: requestForm.email.trim(),
                    phone: requestForm.phone.trim(),
                    status: 'pending',
                    request_date: new Date().toISOString()
                }
            ])
            .select();

        if (error) {
            // Manejar error de constraintUnique
            if (error.code === '23505' && error.message.includes('unique_email_course')) {
                alert('⚠️ Ya has solicitado información para este curso anteriormente. Si tienes dudas adicionales, contacta directamente con nosotros.');
                closeRequestModal();
                return;
            }
            throw error;
        }

        // Actualizar contador de solicitudes en la tabla courses si existe
        try {
            await supabase
                .from('courses')
                .update({ 
                    request_count: (requestingCourse.request_count || 0) + 1 
                })
                .eq('id', requestingCourse.id);
        } catch (updateError) {
            console.warn('Error updating request count:', updateError);
        }
        
        // Mostrar mensaje de éxito más detallado
        alert(`✅ ¡Solicitud enviada exitosamente!
        
📋 Curso: ${requestingCourse.title}
📧 Email: ${requestForm.email}
📱 WhatsApp: ${requestForm.phone}

Nos pondremos en contacto contigo muy pronto por WhatsApp con toda la información detallada del curso.`);
        
        closeRequestModal();
        setRequestForm({
            name: '',
            email: '',
            phone: ''
        });
        
        // Recargar cursos para actualizar el contador
        await loadCourses();
        
    } catch (error) {
        console.error('Error sending request:', error);
        
        // Mensajes de error más específicos
        let errorMessage = '❌ Error al enviar la solicitud. ';
        
        if (error.message.includes('duplicate key value')) {
            errorMessage = '⚠️ Ya has solicitado información para este curso anteriormente.';
        } else if (error.message.includes('network')) {
            errorMessage += 'Verifica tu conexión a internet e intenta nuevamente.';
        } else {
            errorMessage += `${error.message}`;
        }
        
        alert(errorMessage);
    } finally {
        setSubmittingRequest(false);
    }
};

    const showCourseDetails = (course) => {
        setSelectedCourse(course);
        setShowDetailsModal(true);
        // Prevenir scroll del body
        document.body.style.overflow = 'hidden';
    };

    const closeDetailsModal = () => {
        setShowDetailsModal(false);
        setSelectedCourse(null);
        // Restaurar scroll del body
        document.body.style.overflow = 'unset';
    };

    const getStatusInfo = (status) => {
        const statusConfig = {
            available: { 
                class: 'success', 
                text: 'Disponible',
                icon: '✅'
            },
            coming_soon: { 
                class: 'warning', 
                text: 'Próximamente',
                icon: '⏳'
            },
            closed: { 
                class: 'secondary', 
                text: 'Cerrado',
                icon: '🔒'
            }
        };
        return statusConfig[status] || statusConfig.available;
    };

    const getModalityInfo = (modality) => {
        const modalityConfig = {
            virtual: { icon: <MdOnlinePrediction />, class: 'primary' },
            presencial: { icon: <MdLocationOn />, class: 'warning' },
            híbrida: { icon: <FaGraduationCap />, class: 'info' }
        };
        return modalityConfig[modality.toLowerCase()] || modalityConfig.virtual;
    };

    // Función para manejar errores de imagen
    const handleImageError = (e, course) => {
        const categoryImages = {
            'Contratación': 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=200&fit=crop&crop=center&q=80',
            'Legal': 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&h=200&fit=crop&crop=center&q=80',
            'Gestión': 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=200&fit=crop&crop=center&q=80',
            'Finanzas': 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=200&fit=crop&crop=center&q=80',
            'Administración': 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=200&fit=crop&crop=center&q=80'
        };
        e.target.src = categoryImages[course.category] || 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=200&fit=crop&crop=center&q=80';
    };

    const isDiscountActive = (course) => {
        if (!course.discount_deadline || course.discount_percentage <= 0) return false;
        return new Date(course.discount_deadline) >= new Date();
    };

    const getDaysUntilDeadline = (deadline) => {
        const today = new Date();
        const deadlineDate = new Date(deadline);
        const diffTime = deadlineDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays;
    };

    // Efecto para limpiar el overflow cuando el componente se desmonta
    useEffect(() => {
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    if (loading) {
        return (
            <div className="container-fluid py-4">
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '500px' }}>
                    <div className="text-center">
                        <div className="loading-spinner mb-4">
                            <div className="spinner"></div>
                        </div>
                        <h5 className="text-dark mb-2">Descubriendo los mejores cursos para ti...</h5>
                        <p className="text-muted">Cargando contenido premium</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container-fluid py-4">
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '500px' }}>
                    <div className="text-center">
                        <div className="alert alert-danger p-4 rounded-4" style={{ maxWidth: '500px' }}>
                            <h5 className="alert-heading">Error al cargar cursos</h5>
                            <p className="mb-3">{error}</p>
                            <button 
                                className="btn btn-danger"
                                onClick={() => window.location.reload()}
                            >
                                Reintentar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container-fluid py-4">
            {/* Hero Section Premium */}
            <div className="row mb-5">
                <div className="col-12">
                    <div className="hero-section-premium text-white rounded-4 p-5 text-center position-relative overflow-hidden">
                        <div className="hero-background"></div>
                        <div className="hero-content position-relative">
                            <div className="row align-items-center">
                                <div className="col-lg-8 mx-auto">
                                    <div className="hero-badge mb-3">
                                        <span className="badge hero-premium-badge">
                                            <FaBolt className="me-2" />
                                            CURSOS PREMIUM 2025
                                        </span>
                                    </div>
                                    <h1 className="display-3 fw-bold mb-4 hero-title">
                                        Fórmate como un <span className="text-warning">Proveedor del estado</span>
                                    </h1>
                                    <p className="lead mb-4 hero-subtitle">
                                        Capacítate con los mejores especialistas en contratación pública y gestión empresarial.  
                                    </p>
                                    <div className="d-flex justify-content-center gap-4 flex-wrap mb-4">
                                        <div className="stats-premium">
                                            <h3 className="fw-bold mb-0 text-warning">{courses.length}+</h3>
                                            <small>Cursos Especializados</small>
                                        </div>
                                        <div className="stats-premium">
                                            <h3 className="fw-bold mb-0 text-warning">100+</h3>
                                            <small>Profesionales Capacitados</small>
                                        </div>
                                        <div className="stats-premium">
                                            <h3 className="fw-bold mb-0 text-warning">4.8⭐</h3>
                                            <small>Valoración Promedio</small>
                                        </div>
                                    </div>
                                    <div className="hero-action">
                                        <div className="alert alert-warning d-inline-block mb-0 pulse-animation">
                                            <FaFire className="text-danger me-2" />
                                            <strong>¡Oferta limitada!</strong> Hasta 20% DSCTO en cursos seleccionados
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Filtros mejorados */}
            <div className="row mb-4">
                <div className="col-12">
                    <div className="card shadow-lg border-0 filters-premium">
                        <div className="card-body p-4">
                            <div className="row g-3 align-items-end">
                                <div className="col-lg-4">
                                    <label className="form-label fw-bold text-dark">
                                        <FaSearch className="me-2 text-primary" />
                                        Encuentra tu curso ideal
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control form-control-lg premium-input"
                                        placeholder="Buscar por título, instructor, categoría..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                                <div className="col-lg-2">
                                    <label className="form-label fw-bold text-dark">Categoría</label>
                                    <select
                                        className="form-select form-select-lg premium-select"
                                        value={selectedCategory}
                                        onChange={(e) => setSelectedCategory(e.target.value)}
                                    >
                                        <option value="all">Todas</option>
                                        {categories.map(category => (
                                            <option key={category} value={category}>{category}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-2">
                                    <label className="form-label fw-bold text-dark">Modalidad</label>
                                    <select
                                        className="form-select form-select-lg premium-select"
                                        value={selectedModality}
                                        onChange={(e) => setSelectedModality(e.target.value)}
                                    >
                                        <option value="all">Todas</option>
                                        <option value="virtual">Virtual</option>
                                        <option value="presencial">Presencial</option>
                                        <option value="híbrida">Híbrida</option>
                                    </select>
                                </div>
                                <div className="col-lg-2">
                                    <label className="form-label fw-bold text-dark">Precio</label>
                                    <select
                                        className="form-select form-select-lg premium-select"
                                        value={priceRange}
                                        onChange={(e) => setPriceRange(e.target.value)}
                                    >
                                        <option value="all">Todos</option>
                                        <option value="under_300">Menos de S/300</option>
                                        <option value="300_500">S/300 - S/500</option>
                                        <option value="over_500">Más de S/500</option>
                                    </select>
                                </div>
                                <div className="col-lg-2">
                                    <div className="text-center">
                                        <span className="badge bg-gradient-primary fs-6 px-3 py-2 results-badge">
                                            {filteredCourses.length} curso(s) encontrado(s)
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Grid de Cursos Premium */}
            <div className="row">
                {filteredCourses.map((course, index) => {
                    const statusInfo = getStatusInfo(course.status);
                    const modalityInfo = getModalityInfo(course.modality);
                    const discountActive = isDiscountActive(course);
                    const daysLeft = discountActive ? getDaysUntilDeadline(course.discount_deadline) : 0;

                    return (
                        <div key={course.id} className="col-xl-4 col-lg-6 mb-4">
                            <div className="card course-card-premium h-100 border-0 shadow-lg position-relative" 
                                 style={{ animationDelay: `${index * 0.1}s` }}>
                                
                                {/* Badges superiores */}
                                <div className="position-absolute top-0 start-0 m-3 z-index-10">
                                    {course.isBestseller && (
                                        <span className="badge bestseller-badge mb-2 d-block">
                                            <FaFire className="me-1" />
                                            BESTSELLER
                                        </span>
                                    )}
                                    {course.isHot && (
                                        <span className="badge hot-badge mb-2 d-block">
                                            <FaBolt className="me-1" />
                                            TRENDING
                                        </span>
                                    )}
                                </div>

                                {/* Descuento destacado */}
                                {discountActive && (
                                    <div className="discount-ribbon">
                                        <div className="ribbon-content">
                                            <div className="discount-percentage">-{course.discount_percentage}%</div>
                                            <div className="ribbon-text">DESCUENTO</div>
                                        </div>
                                    </div>
                                )}

                                {/* Imagen del curso */}
                                <div className="course-image-premium position-relative overflow-hidden">
                                    <img 
                                        src={course.imageUrl}
                                        className="card-img-top course-image-enhanced" 
                                        alt={course.title}
                                        onError={(e) => handleImageError(e, course)}
                                    />
                                    
                                    {/* Overlay con información rápida */}
                                    <div className="course-overlay-premium">
                                        <div className="overlay-content">
                                            <button 
                                                className="btn btn-light btn-sm overlay-btn-premium mb-2"
                                                onClick={() => showCourseDetails(course)}
                                            >
                                                <FaInfoCircle className="me-1" />
                                                Ver detalles completos
                                            </button>
                                            <div className="overlay-info">
    <small className="text-white d-block">
        <FaClock className="me-1" />
        {course.duration}
    </small>
    <div className="text-white d-block overlay-date-premium">
        <FaCalendarAlt className="me-2" />
        <strong>Inicia: {new Date(course.start_date).toLocaleDateString('es-ES')}</strong>
    </div>
</div>
                                        </div>
                                    </div>

                                    {/* Badge de modalidad */}
                                    <div className="position-absolute bottom-0 start-0 m-3">
                                        <span className={`badge bg-${modalityInfo.class} modality-badge-premium`}>
                                            {modalityInfo.icon} {course.modality}
                                        </span>
                                    </div>
                                </div>

                                <div className="card-body d-flex flex-column p-4">
                                    {/* Categoría y rating */}
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <span className="badge category-badge-premium">{course.category}</span>
                                        
                                        <div className="rating-premium">
                                            <FaStar className="text-warning me-1" />
                                            <span className="fw-bold text-dark">{course.rating}</span>
                                            <small className="text-muted ms-1">({course.reviewsCount})</small>
                                        </div>
                                    </div>

                                    {/* Título del curso */}
                                    <h3 className="card-title fw-bold text-dark mb-3 course-title-premium-enhanced">
                                        {course.title}
                                    </h3>

                                    {/* Instructor destacado */}
 <div className="instructor-section-premium mb-3">
    <div className="d-flex align-items-center">
       <div className="instructor-avatar me-3">
    {course.company_logo_url ? (
        <img 
            src={course.company_logo_url}
            alt={`Logo ${course.company_name}`}
            className="company-logo"
            onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
            }}
        />
    ) : null}
    <div className="company-logo-fallback" style={{ display: course.company_logo_url ? 'none' : 'flex' }}>
        <FaBuilding className="text-primary" size={24} />
    </div>
</div>
        <div className="instructor-info flex-grow-1">
            {/* AGREGAR: Mostrar empresa primero */}
            <div className="company-name mb-1">
                {course.company_name}
            </div>
            <div className="instructor-name fw-bold text-dark">
                {course.instructor}
            </div>
            <small className="instructor-title text-muted">
                {course.instructor_title}
            </small>
        </div>
    </div>
</div>

                                    {/* Descripción mejorada */}
                                 <div className="description-section mb-3">
    <p className="card-text text-muted description-premium flex-grow-1">
        {expandedDescriptions[course.id] 
            ? course.description 
            : (course.description.length > 150 
                ? `${course.description.substring(0, 150)}...` 
                : course.description)
        }
    </p>
    {course.description.length > 150 && (
        <div className="text-center mt-2">
            <button 
                className="btn btn-outline-primary btn-sm description-toggle-btn"
                onClick={() => toggleDescription(course.id)}
            >
                {expandedDescriptions[course.id] ? (
                    <>
                        <FaEyeSlash className="me-2" />
                        Mostrar menos descripción
                    </>
                ) : (
                    <>
                        <FaEye className="me-2" />
                        Leer descripción completa
                    </>
                )}
            </button>
        </div>
    )}
</div>
                                    {/* Highlights destacados */}
                                    <div className="highlights-section mb-3">
                                        <div className="d-flex flex-wrap gap-1">
                                            {course.highlights.slice(0, 3).map((highlight, index) => (
                                                <span key={index} className="badge highlight-badge-premium">
                                                    <FaCheckCircle className="me-1" size={10} />
                                                    {highlight}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
{/* AGREGAR: Fecha de inicio destacada */}
<div className="start-date-section">
    <div className="start-date-banner">
        <div className="start-date-icon">
            <FaCalendarAlt className="text-primary" />
        </div>
        <div className="start-date-content">
            <div className="start-date-label">Inicia</div>
            <div className="start-date-value">
                {new Date(course.start_date).toLocaleDateString('es-ES', { 
                    weekday: 'long', 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                })}
            </div>
        </div>
    </div>
</div>
                                    {/* Información de tiempo limitado */}
                                    {discountActive && daysLeft <= 7 && (
                                        <div className="urgency-alert mb-3">
                                            <div className="alert alert-warning py-2 px-3 mb-0 urgency-banner">
                                                <small className="fw-bold text-dark">
                                                    <MdAccessTime className="me-1 text-danger" />
                                                    ¡Solo quedan {daysLeft} día(s) con descuento!
                                                </small>
                                            </div>
                                        </div>
                                    )}

{/* Precios destacados */}
<div className="pricing-section-premium mb-3">
    {discountActive ? (
        <div className="pricing-card-discount">
            {/* Header del descuento */}
            <div className="discount-header">
                <div className="discount-badge-new">
                    <FaTag className="discount-icon" />
                    -{course.discount_percentage}% DSCTO
                </div>
                {daysLeft <= 7 && (
                    <div className="expiry-info">
                        <MdAccessTime />
                        {daysLeft} día(s) restantes
                    </div>
                )}
            </div>
            
            {/* Comparación de precios mejorada */}
            <div className="price-comparison-new">
                <div className="price-before-section">
                    <span className="price-label">Precio Normal</span>
                    <div className="price-before-value">S/. {course.regular_price}</div>
                </div>
                <div className="price-after-section">
                    <span className="price-label-discount">Precio Promocional</span>
                    <div className="price-after-value">S/. {course.discounted_price}</div>
                </div>
            </div>
            
            {/* Ahorro destacado */}
            <div className="savings-highlight">
                <FaCheckCircle className="savings-icon" />
                ¡Ahorras S/. {(course.regular_price - course.discounted_price).toFixed(0)}!
            </div>
        </div>
    ) : (
        <div className="pricing-card-regular">
            <div className="price-regular-section">
                <span className="price-label-regular">Inversión Total</span>
                <div className="price-value-regular">S/. {course.regular_price}</div>
            </div>
        </div>
    )}
</div>

                                    {/* Botón de acción principal */}
                                    <div className="action-section mt-auto">
                                        <button 
                                            className="btn btn-primary btn-lg w-100 cta-button-premium"
                                            onClick={() => handleRequestInfo(course)}
                                        >
                                            
                                            Solicitar Información
                                        </button>
                                        <div className="text-center mt-2">
                                            <small className="text-muted">
                                                <FaCheckCircle className="text-success me-1" />
                                                Deja tus datos y te contactaremos por Whatsapp
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Estado vacío mejorado */}
            {filteredCourses.length === 0 && !loading && (
                <div className="row">
                    <div className="col-12">
                        <div className="empty-state-premium text-center py-5">
                            <div className="mb-4">
                                <MdSchool size={100} className="text-muted" />
                           </div>
                           <h3 className="text-dark mb-3">No encontramos cursos que coincidan</h3>
                           <p className="text-muted mb-4 lead">
                               Intenta ajustar los filtros o explora nuestras categorías más populares
                           </p>
                           <button 
                               className="btn btn-primary btn-lg"
                               onClick={() => {
                                   setSearchTerm('');
                                   setSelectedCategory('all');
                                   setSelectedModality('all');
                                   setPriceRange('all');
                               }}
                           >
                               Ver todos los cursos
                           </button>
                       </div>
                   </div>
               </div>
           )}

           {/* Modal de solicitud de información */}
           {showRequestModal && requestingCourse && (
               <div className="modal-overlay" onClick={closeRequestModal}>
                   <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                       <div className="modal-content-custom">
                           <div className="modal-header-custom">
                               <div className="w-100">
                                   <div className="text-center mb-3">
                                       <div className="modal-icon-premium mb-3">
                                           <FaWhatsapp size={48} className="text-success" />
                                       </div>
                                       <h4 className="modal-title fw-bold text-dark">
                                           Solicitar Información
                                       </h4>
                                       <p className="text-muted">
                                           Completa el formulario y recibe información detallada por WhatsApp
                                       </p>
                                   </div>
                               </div>
                               <button 
                                   type="button" 
                                   className="btn-close-custom"
                                   onClick={closeRequestModal}
                               >
                                   <FaTimes />
                               </button>
                           </div>
                           <div className="modal-body-custom">
                               {/* Información del curso */}
                               <div className="course-info-banner mb-4">
                                   <div className="row align-items-center">
                                       <div className="col-md-8">
                                           <h5 className="mb-1 text-dark">{requestingCourse.title}</h5>
                                           <div className="d-flex align-items-center gap-3">
                                               <small className="text-muted">
                                                   <MdBusiness className="me-1" />
                                                   {requestingCourse.company_name}
                                               </small>
                                               <small className="text-muted">
                                                   <FaClock className="me-1" />
                                                   {requestingCourse.duration}
                                               </small>
                                           </div>
                                       </div>
                                       <div className="col-md-4 text-md-end">
                                           {isDiscountActive(requestingCourse) ? (
                                               <div>
                                                   <div className="text-decoration-line-through text-muted">
                                                       S/. {requestingCourse.regular_price}
                                                   </div>
                                                   <div className="text-success fw-bold fs-4">
                                                       S/. {requestingCourse.discounted_price}
                                                   </div>
                                               </div>
                                           ) : (
                                               <div className="text-success fw-bold fs-4">
                                                   S/. {requestingCourse.regular_price}
                                               </div>
                                           )}
                                       </div>
                                   </div>
                               </div>

                               {/* Formulario */}
                               <div>
                                   <div className="row">
                                       <div className="col-md-6 mb-3">
                                           <label className="form-label fw-semibold">Nombre completo *</label>
                                           <input
                                               type="text"
                                               className="form-control form-control-lg premium-input"
                                               placeholder="Ej: Juan Pérez García"
                                               value={requestForm.name}
                                               onChange={(e) => setRequestForm({...requestForm, name: e.target.value})}
                                               required
                                           />
                                       </div>
                                       <div className="col-md-6 mb-3">
                                           <label className="form-label fw-semibold">Email *</label>
                                           <input
                                               type="email"
                                               className="form-control form-control-lg premium-input"
                                               placeholder="correo@empresa.com"
                                               value={requestForm.email}
                                               onChange={(e) => setRequestForm({...requestForm, email: e.target.value})}
                                               required
                                           />
                                       </div>
                                      
                                       <div className="col-12 mb-4">
                                           <label className="form-label fw-semibold">WhatsApp *</label>
                                           <input
                                               type="tel"
                                               className="form-control form-control-lg premium-input"
                                               placeholder="+51 987 654 321"
                                               value={requestForm.phone}
                                               onChange={(e) => setRequestForm({...requestForm, phone: e.target.value})}
                                               required
                                           />
                                           <small className="form-text text-muted">
                                               Te contactaremos por WhatsApp a este número
                                           </small>
                                       </div>
                                   </div>

                                   <div className="alert alert-info mb-4">
                                       <h6 className="alert-heading mb-2">
                                           <FaInfoCircle className="me-2" />
                                           ¿Qué recibirás?
                                       </h6>
                                       <ul className="mb-0 small">
                                           <li>Información detallada del curso y temario completo</li>
                                           <li>Opciones de pago y modalidades de financiamiento</li>
                                           <li>Cronograma de clases y certificación</li>
                                           <li>Descuentos especiales por pronto pago</li>
                                       </ul>
                                   </div>

                                   <div className="d-grid">
                                       <button 
                                           type="button" 
                                           className="btn btn-success btn-lg"
                                           disabled={submittingRequest}
                                           onClick={handleSubmitRequest}
                                       >
                                           {submittingRequest ? (
                                               <>
                                                   <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                   Enviando solicitud...
                                               </>
                                           ) : (
                                               <>
                                                   <FaWhatsapp className="me-2" />
                                                   Enviar Solicitud por WhatsApp
                                               </>
                                           )}
                                       </button>
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
           )}

           {/* Modal de detalles del curso mejorado */}
           {showDetailsModal && selectedCourse && (
               <div className="modal-overlay" onClick={closeDetailsModal}>
                   <div className="modal-container-large" onClick={(e) => e.stopPropagation()}>
                       <div className="modal-content-custom">
                           <div className="modal-header-custom">
                               <div className="d-flex align-items-center w-100">
                                   <MdSchool className="text-primary me-3" size={32} />
                                   <div className="flex-grow-1">
                                       <h4 className="modal-title fw-bold text-dark mb-1">{selectedCourse.title}</h4>
                                       <div className="d-flex align-items-center gap-3">
                                           <span className="badge category-badge-premium">{selectedCourse.category}</span>
                                           <span className="badge bg-info">{selectedCourse.level}</span>

                                       </div>
                                   </div>
                               </div>
                               <button 
                                   type="button" 
                                   className="btn-close-custom"
                                   onClick={closeDetailsModal}
                               >
                                   <FaTimes />
                               </button>
                           </div>
                           <div className="modal-body-custom">
                               {/* Imagen destacada */}
                               <img 
                                   src={selectedCourse.imageUrl}
                                   className="img-fluid rounded-3 mb-4 w-100 modal-image-premium"
                                   alt={selectedCourse.title}
                                   onError={(e) => handleImageError(e, selectedCourse)}
                               />

                               <div className="row">
                                   <div className="col-lg-8">
                                       {/* Descripción completa */}
                                       <div className="section-premium mb-4">
                                           <h5 className="section-title-premium">Descripción del Curso</h5>
                                           <p className="text-dark lh-lg">{selectedCourse.description}</p>
                                       </div>

                                       {/* Objetivos */}
                                       <div className="section-premium mb-4">
                                           <h5 className="section-title-premium">Objetivos de Aprendizaje</h5>
                                           <p className="text-dark">{selectedCourse.objectives}</p>
                                       </div>

                                       {/* Temario */}
                                       <div className="section-premium mb-4">
                                           <h5 className="section-title-premium">Temario del Curso</h5>
                                           <div className="syllabus-premium">
                                               <pre className="syllabus-content">{selectedCourse.syllabus}</pre>
                                           </div>
                                       </div>

                                       {/* Requisitos */}
                                       <div className="section-premium mb-4">
                                           <h5 className="section-title-premium">Requisitos</h5>
                                           <p className="text-dark">{selectedCourse.requirements}</p>
                                       </div>

                                       {/* Highlights */}
                                       <div className="section-premium mb-4">
                                           <h5 className="section-title-premium">Lo que incluye</h5>
                                           <div className="row">
                                               {selectedCourse.highlights.map((highlight, index) => (
                                                   <div key={index} className="col-md-6 mb-2">
                                                       <div className="d-flex align-items-center">
                                                           <FaCheckCircle className="text-success me-2" />
                                                           <span className="text-dark">{highlight}</span>
                                                       </div>
                                                   </div>
                                               ))}
                                           </div>
                                       </div>
                                   </div>

                                   <div className="col-lg-4">
                                       {/* Card de información del curso */}
                                       <div className="card course-info-card">
                                           <div className="card-body">
                                               {/* Instructor */}
                                               <div className="instructor-card mb-4">
                                                   <div className="d-flex align-items-center mb-3">
                                                       <div className="instructor-avatar-large me-3">
                                                           <FaGraduationCap className="text-primary" size={32} />
                                                       </div>
                                                       <div>
                                                           <div className="fw-bold text-dark">{selectedCourse.instructor}</div>
                                                           <small className="text-muted">{selectedCourse.instructor_title}</small>
                                                       </div>
                                                   </div>
                                               </div>

                                               {/* Detalles del curso */}
                                               <div className="course-details-list mb-4">
                                                   <div className="detail-item-premium mb-3">
                                                       <div className="d-flex align-items-center">
                                                           <MdBusiness className="text-primary me-2" />
                                                           <div>
                                                               <div className="fw-semibold">Empresa</div>
                                                               <div className="text-muted">{selectedCourse.company_name}</div>
                                                           </div>
                                                       </div>
                                                   </div>

                                                   <div className="detail-item-premium mb-3">
                                                       <div className="d-flex align-items-center">
                                                           <FaClock className="text-primary me-2" />
                                                           <div>
                                                               <div className="fw-semibold">Duración</div>
                                                               <div className="text-muted">{selectedCourse.duration}</div>
                                                           </div>
                                                       </div>
                                                   </div>

                                                   <div className="detail-item-premium mb-3">
                                                       <div className="d-flex align-items-center">
                                                           <FaCalendarAlt className="text-primary me-2" />
                                                           <div>
                                                               <div className="fw-semibold">Fechas</div>
                                                               <div className="text-muted">
                                                                   {new Date(selectedCourse.start_date).toLocaleDateString('es-ES')} - 
                                                                   {new Date(selectedCourse.end_date).toLocaleDateString('es-ES')}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </div>

                                                   <div className="detail-item-premium mb-3">
                                                       <div className="d-flex align-items-center">
                                                           {getModalityInfo(selectedCourse.modality).icon}
                                                           <div className="ms-2">
                                                               <div className="fw-semibold">Modalidad</div>
                                                               <div className="text-muted">{selectedCourse.modality}</div>
                                                           </div>
                                                       </div>
                                                   </div>
                                               </div>

                                               {/* Pricing destacado */}
                                               <div className="pricing-card-premium mb-4">
                                                   {isDiscountActive(selectedCourse) ? (
                                                       <>
                                                           <div className="discount-info-large mb-2">
                                                               <span className="discount-badge-large">
                                                                   -{selectedCourse.discount_percentage}% DSCTO
                                                               </span>
                                                           </div>
                                                           <div className="price-comparison">
                                                               <div className="original-price-large">S/. {selectedCourse.regular_price}</div>
                                                               <div className="discounted-price-large">S/. {selectedCourse.discounted_price}</div>
                                                           </div>
                                                           <div className="savings-large">
                                                               Ahorras S/. {(selectedCourse.regular_price - selectedCourse.discounted_price).toFixed(2)}
                                                           </div>
                                                           {getDaysUntilDeadline(selectedCourse.discount_deadline) <= 7 && (
                                                               <div className="urgency-large mt-2">
                                                                   <small className="text-danger fw-bold">
                                                                       ⏰ Oferta termina en {getDaysUntilDeadline(selectedCourse.discount_deadline)} día(s)
                                                                   </small>
                                                               </div>
                                                           )}
                                                       </>
                                                   ) : (
                                                       <div className="regular-price-large">
                                                           S/. {selectedCourse.regular_price}
                                                       </div>
                                                   )}
                                               </div>
{/* Sección de Brochure */}
{selectedCourse.brochure_url && (
    <div className="brochure-section mb-4">
        <h6 className="fw-bold text-dark mb-2">
            <FaFileDownload className="me-2 text-primary" />
            Brochure del Curso
        </h6>
        <div className="d-grid">
            <a 
                href={selectedCourse.brochure_url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-info btn-lg brochure-link"
            >
                <FaEye className="me-2" />
                Ver Brochure Completo
            </a>
        </div>
        <small className="text-muted d-block text-center mt-2">
            Se abrirá en una nueva pestaña
        </small>
    </div>
)}
                                               {/* Botón de acción */}
                                               <div className="d-grid">
                                                   <button 
                                                       className="btn btn-success btn-lg"
                                                       onClick={() => {
                                                           closeDetailsModal();
                                                           handleRequestInfo(selectedCourse);
                                                       }}
                                                   >
                                                       <FaWhatsapp className="me-2" />
                                                       Solicitar Información
                                                   </button>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
           )}

           {/* CSS personalizado premium */}
           <style jsx>{`
               /* ===== VARIABLES PREMIUM ===== */
               :root {
                   --primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                   --success-gradient: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
                   --warning-gradient: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
                   --danger-gradient: linear-gradient(135deg, #fc466b 0%, #3f5efb 100%);
                   --gold-gradient: linear-gradient(135deg, #f7971e 0%, #ffd200 100%);
                   --premium-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
                   --premium-shadow-hover: 0 30px 60px rgba(0, 0, 0, 0.15);
                   --border-radius-premium: 1.5rem;
                   --transition-premium: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
               }

               /* ===== LOADING PREMIUM ===== */
               .loading-spinner .spinner {
                   width: 60px;
                   height: 60px;
                   border: 4px solid #f3f3f3;
                   border-top: 4px solid #667eea;
                   border-radius: 50%;
                   animation: spin 1s linear infinite;
               }

               @keyframes spin {
                   0% { transform: rotate(0deg); }
                   100% { transform: rotate(360deg); }
               }

               /* ===== MODAL OVERLAY MEJORADO ===== */
               .modal-overlay {
                   position: fixed;
                   top: 0;
                   left: 0;
                   width: 100%;
                   height: 100vh;
                   background: rgba(0, 0, 0, 0.7);
                   backdrop-filter: blur(5px);
                   z-index: 1050;
                   display: flex;
                   align-items: center;
                   justify-content: center;
                   padding: 20px;
                   animation: fadeIn 0.3s ease-out;
               }

               .modal-container {
                   width: 100%;
                   max-width: 600px;
                   max-height: 90vh;
                   overflow-y: auto;
                   animation: slideInUp 0.3s ease-out;
               }

               .modal-container-large {
                   width: 100%;
                   max-width: 1200px;
                   max-height: 90vh;
                   overflow-y: auto;
                   animation: slideInUp 0.3s ease-out;
               }

               .modal-content-custom {
                   background: white;
                   border-radius: var(--border-radius-premium);
                   box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
                   overflow: hidden;
               }

               .modal-header-custom {
                   padding: 2rem;
                   border-bottom: 1px solid #e5e7eb;
                   position: relative;
               }

               .modal-body-custom {
                   padding: 2rem;
               }

               .btn-close-custom {
                   position: absolute;
                   top: 1rem;
                   right: 1rem;
                   background: none;
                   border: none;
                   font-size: 1.5rem;
                   color: #6b7280;
                   cursor: pointer;
                   width: 40px;
                   height: 40px;
                   border-radius: 50%;
                   display: flex;
                   align-items: center;
                   justify-content: center;
                   transition: var(--transition-premium);
               }

               .btn-close-custom:hover {
                   background: #f3f4f6;
                   color: #374151;
               }

               @keyframes fadeIn {
                   from { opacity: 0; }
                   to { opacity: 1; }
               }

               @keyframes slideInUp {
                   from {
                       opacity: 0;
                       transform: translateY(50px);
                   }
                   to {
                       opacity: 1;
                       transform: translateY(0);
                   }
               }

               /* ===== HERO SECTION PREMIUM ===== */
               .hero-section-premium {
                   background: var(--primary-gradient);
                   position: relative;
                   overflow: hidden;
                   min-height: 400px;
                   border-radius: var(--border-radius-premium);
               }

               .hero-background::before {
                   content: '';
                   position: absolute;
                   top: 0;
                   left: 0;
                   right: 0;
                   bottom: 0;
                   background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="hero-pattern" width="30" height="30" patternUnits="userSpaceOnUse"><circle cx="15" cy="15" r="2" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23hero-pattern)"/></svg>');
               }

               .hero-content {
                   z-index: 2;
               }

               .hero-premium-badge {
                   background: var(--gold-gradient);
                   border: none;
                   font-weight: 700;
                   padding: 0.75rem 1.5rem;
                   border-radius: 2rem;
                   font-size: 0.9rem;
                   letter-spacing: 0.5px;
                   box-shadow: 0 8px 20px rgba(247, 151, 30, 0.3);
               }

               .hero-title {
                   text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
                   line-height: 1.2;
               }

               .hero-subtitle {
                   font-size: 1.2rem;
                   opacity: 0.95;
               }

               .stats-premium {
                   background: rgba(255, 255, 255, 0.15);
                   padding: 1.5rem;
                   border-radius: var(--border-radius-premium);
                   backdrop-filter: blur(10px);
                   border: 1px solid rgba(255, 255, 255, 0.2);
                   min-width: 140px;
                   transition: var(--transition-premium);
               }

               .stats-premium:hover {
                   transform: translateY(-5px);
                   background: rgba(255, 255, 255, 0.2);
               }

               .pulse-animation {
                   animation: pulse 2s infinite;
                   border: none !important;
                   background: rgba(255, 193, 7, 0.9) !important;
                   color: #000 !important;
                   border-radius: 2rem;
                   font-weight: 600;
               }

               @keyframes pulse {
                   0% { transform: scale(1); }
                   50% { transform: scale(1.05); }
                   100% { transform: scale(1); }
               }

               /* ===== FILTROS PREMIUM ===== */
               .filters-premium {
                   background: white;
                   border-radius: var(--border-radius-premium);
                   box-shadow: var(--premium-shadow);
                   border: none;
               }

               .premium-input,
               .premium-select {
                   border: 2px solid #e2e8f0;
                   border-radius: 1rem;
                   padding: 0.875rem 1.25rem;
                   font-size: 1rem;
                   transition: var(--transition-premium);
                   background: white;
               }

               .premium-input:focus,
               .premium-select:focus {
                   border-color: #667eea;
                   box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
                   outline: none;
               }

               .results-badge {
                   background: var(--primary-gradient) !important;
                   border: none;
                   border-radius: 1.5rem;
                   padding: 0.75rem 1.5rem;
                   font-weight: 600;
               }

               /* ===== COURSE CARDS PREMIUM ===== */
               .course-card-premium {
                   background: white;
                   border-radius: var(--border-radius-premium);
                   overflow: hidden;
                   transition: var(--transition-premium);
                   box-shadow: var(--premium-shadow);
                   animation: fadeInUp 0.8s ease-out;
                   position: relative;
               }

               .course-card-premium:hover {
                   transform: translateY(-15px);
                   box-shadow: var(--premium-shadow-hover);
               }

               .course-image-premium {
                   height: 250px;
                   position: relative;
                   overflow: hidden;
               }

               .course-image-enhanced {
                   height: 100%;
                   width: 100%;
                   object-fit: cover;
                   transition: transform 0.6s ease;
               }

               .course-card-premium:hover .course-image-enhanced {
                   transform: scale(1.1);
               }

               .course-overlay-premium {
                   position: absolute;
                   top: 0;
                   left: 0;
                   right: 0;
                   bottom: 0;
                   background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 70%);
                   display: flex;
                   align-items: flex-end;
                   justify-content: center;
                   padding: 2rem;
                   opacity: 0;
                   transition: opacity 0.4s ease;
               }

               .course-card-premium:hover .course-overlay-premium {
                   opacity: 1;
               }

               .overlay-content {
                   text-align: center;
               }

               .overlay-btn-premium {
                   background: white;
                   border: none;
                   border-radius: 2rem;
                   padding: 0.75rem 1.5rem;
                   font-weight: 600;
                   color: #333;
                   transition: var(--transition-premium);
                   box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
               }

               .overlay-btn-premium:hover {
                   background: var(--primary-gradient);
                   color: white;
                   transform: scale(1.05);
               }

               .overlay-info small {
                   display: block;
                   margin-top: 0.5rem;
                   opacity: 0.9;
               }

               /* ===== BADGES PREMIUM ===== */
               .bestseller-badge {
                   background: var(--danger-gradient) !important;
                   border: none;
                   font-weight: 700;
                   padding: 0.5rem 1rem;
                   border-radius: 1.5rem;
                   font-size: 0.75rem;
                   letter-spacing: 0.5px;
                   box-shadow: 0 4px 15px rgba(252, 70, 107, 0.4);
                   animation: glow 2s ease-in-out infinite alternate;
               }

               .hot-badge {
                   background: var(--warning-gradient) !important;
                   border: none;
                   font-weight: 700;
                   padding: 0.5rem 1rem;
                   border-radius: 1.5rem;
                   font-size: 0.75rem;
                   letter-spacing: 0.5px;
                   box-shadow: 0 4px 15px rgba(240, 147, 251, 0.4);
               }

               @keyframes glow {
                   from { box-shadow: 0 4px 15px rgba(252, 70, 107, 0.4); }
                   to { box-shadow: 0 4px 25px rgba(252, 70, 107, 0.6); }
               }

               .discount-ribbon {
                   position: absolute;
                   top: 15px;
                   right: -30px;
                   z-index: 5;
                   transform: rotate(45deg);
                        background: linear-gradient(135deg, #059669 0%, #10b981 100%);
    padding: 0.5rem 2.5rem;
    box-shadow: 0 4px 15px rgba(5, 150, 105, 0.5);
               }

               .ribbon-content {
                   text-align: center;
                   color: white;
                   font-weight: 700;
                   font-size:0.8rem;
               }

               .discount-percentage {
                   font-size: 1rem;
                   line-height: 1;
               }

               .ribbon-text {
                   font-size: 0.6rem;
                   letter-spacing: 1px;
               }

               .category-badge-premium {
                   background: linear-gradient(135deg, #e0e7ff, #c7d2fe);
                   color: #3730a3;
                   border: 2px solid #a5b4fc;
                   font-weight: 600;
                   padding: 0.5rem 1rem;
                   border-radius: 1.5rem;
                   font-size: 0.75rem;
               }

               .modality-badge-premium {
                   font-weight: 600;
                   padding: 0.5rem 1rem;
                   border-radius: 1.5rem;
                   backdrop-filter: blur(10px);
                   border: 1px solid rgba(255, 255, 255, 0.3);
               }

               .highlight-badge-premium {
                   background: linear-gradient(135deg, #d1fae5, #a7f3d0);
                   color: #065f46;
                   border: 1px solid #6ee7b7;
                   font-weight: 500;
                   padding: 0.25rem 0.75rem;
                   border-radius: 1rem;
                   font-size: 0.7rem;
               }

               /* ===== CONTENIDO DE CARDS ===== */
               .course-title-premium {
                   font-size: 1.25rem;
                   line-height: 1.3;
                   min-height: 3.25rem;
                   color: #1a202c;
               }

               .instructor-section-premium {
                   background: linear-gradient(135deg, #f8fafc, #e2e8f0);
                   padding: 1rem;
                   border-radius: 1rem;
                   border: 1px solid #e2e8f0;
               }

               .instructor-avatar {
                   width: 48px;
                   height: 48px;
                   background: linear-gradient(135deg, #ddd6fe, #c4b5fd);
                   border-radius: 50%;
                   display: flex;
                   align-items: center;
                   justify-content: center;
               }

               .instructor-name {
                   font-size: 1rem;
                   color: #1a202c;
                   line-height: 1.2;
               }

               .instructor-title {
                   font-size: 0.8rem;
                   color: #6b7280;
               }

               .description-premium {
                   font-size: 0.95rem;
                   line-height: 1.6;
                   color: #4b5563;
                   height: auto;
                   min-height: 4.5rem;
               }

               .rating-premium {
                   display: flex;
                   align-items: center;
                   background: rgba(255, 255, 255, 0.9);
                   padding: 0.25rem 0.75rem;
                   border-radius: 1rem;
                   border: 1px solid #e5e7eb;
               }

               /* ===== PRECIOS PREMIUM ===== */
               .pricing-with-discount {
                   background: linear-gradient(135deg, #ecfdf5, #d1fae5);
                   padding: 1rem;
                   border-radius: 1rem;
                   border: 2px solid #6ee7b7;
               }

               .original-price {
                   font-size: 1rem;
                   color: #6b7280;
                   text-decoration: line-through;
                   text-decoration-thickness: 2px;
               }

               .discounted-price {
                   font-size: 1.75rem;
                   font-weight: 700;
                   color: #059669;
               }

               .savings-info {
                   font-size: 0.85rem;
                   color: #065f46;
               }

               .regular-pricing {
                   text-align: center;
               }

               .price-regular {
                   font-size: 1.75rem;
                   font-weight: 700;
                   color: #059669;
                   margin: 0;
               }

               .urgency-alert {
                   animation: pulse 2s infinite;
               }

               .urgency-banner {
                   background: linear-gradient(135deg, #fef3c7, #fde68a) !important;
                   border: 2px solid #f59e0b !important;
                   border-radius: 1rem !important;
               }

               /* ===== BOTONES PREMIUM ===== */
               .cta-button-premium {
                   background: var(--success-gradient) !important;
                   border: none;
                   border-radius: 2rem;
                   font-weight: 600;
                   padding: 1rem 2rem;
                   font-size: 1rem;
                   transition: var(--transition-premium);
                   box-shadow: 0 8px 20px rgba(17, 153, 142, 0.3);
                   text-transform: uppercase;
                   letter-spacing: 0.5px;
               }

               .cta-button-premium:hover {
                   transform: translateY(-3px);
                   box-shadow: 0 12px 30px rgba(17, 153, 142, 0.4);
                   background: var(--success-gradient) !important;
               }

               /* ===== MODAL ELEMENTS ===== */
               .modal-icon-premium {
                   width: 80px;
                   height: 80px;
                   background: linear-gradient(135deg, #dcfce7, #bbf7d0);
                   border-radius: 50%;
                   display: flex;
                   align-items: center;
                   justify-content: center;
                   margin: 0 auto;
                   border: 3px solid #22c55e;
               }

               .course-info-banner {
                   background: linear-gradient(135deg, #f8fafc, #e2e8f0);
                   padding: 1.5rem;
                   border-radius: 1rem;
                   border: 1px solid #e2e8f0;
               }

               .modal-image-premium {
                   height: 250px;
                   object-fit: cover;
                   border-radius: 1rem;
               }

               .section-premium {
                   border-bottom: 1px solid #e5e7eb;
                   padding-bottom: 1.5rem;
               }

               .section-title-premium {
                   color: #1f2937;
                   font-weight: 700;
                   font-size: 1.1rem;
                   margin-bottom: 1rem;
                   position: relative;
                   padding-left: 1rem;
               }

               .section-title-premium::before {
                   content: '';
                   position: absolute;
                   left: 0;
                   top: 0;
                   bottom: 0;
                   width: 4px;
                   background: var(--primary-gradient);
                   border-radius: 2px;
               }

               .syllabus-premium {
                   background: linear-gradient(135deg, #f8fafc, #e2e8f0);
                   padding: 1.5rem;
                   border-radius: 1rem;
                   border: 1px solid #d1d5db;
               }

               .syllabus-content {
                   margin: 0;
                   font-family: 'Segoe UI', system-ui, sans-serif;
                   font-size: 0.95rem;
                   line-height: 1.6;
                   color: #374151;
                   white-space: pre-wrap;
                   background: none;
                   border: none;
               }

               .course-info-card {
                   background: linear-gradient(135deg, #fefefe, #f8fafc);
                   border: 2px solid #e5e7eb;
                   border-radius: var(--border-radius-premium);
                   box-shadow: var(--premium-shadow);
                   position: sticky;
                   top: 2rem;
               }

               .instructor-card {
                   background: white;
                   padding: 1rem;
                   border-radius: 1rem;
                   border: 1px solid #e5e7eb;
               }

               .instructor-avatar-large {
                   width: 60px;
                   height: 60px;
                   background: var(--primary-gradient);
                   border-radius: 50%;
                   display: flex;
                   align-items: center;
                   justify-content: center;
                   color: white;
               }

               .detail-item-premium {
                   padding: 0.75rem 0;
                   border-bottom: 1px solid #f3f4f6;
               }

               .detail-item-premium:last-child {
                   border-bottom: none;
               }

               /* ===== PRICING CARD PREMIUM ===== */
               .pricing-card-premium {
                   background: linear-gradient(135deg, #ecfdf5, #d1fae5);
                   padding: 1.5rem;
                   border-radius: 1rem;
                   border: 2px solid #6ee7b7;
                   text-align: center;
               }

               .discount-info-large {
                   margin-bottom: 1rem;
               }

               .discount-badge-large {
                   background: var(--danger-gradient);
                   color: white;
                   padding: 0.5rem 1rem;
                   border-radius: 1.5rem;
                   font-weight: 700;
                   font-size: 0.9rem;
                   display: inline-block;
                   box-shadow: 0 4px 15px rgba(252, 70, 107, 0.4);
               }

               .price-comparison {
                   margin-bottom: 1rem;
               }

               .original-price-large {
                   font-size: 1.25rem;
                   color: #6b7280;
                   text-decoration: line-through;
                   text-decoration-thickness: 2px;
                   margin-bottom: 0.5rem;
               }

               .discounted-price-large {
                   font-size: 2.5rem;
                   font-weight: 700;
                   color: #059669;
                   line-height: 1;
               }

               .regular-price-large {
                   font-size: 2.5rem;
                   font-weight: 700;
                   color: #059669;
                   line-height: 1;
               }

               .savings-large {
                   font-size: 1rem;
                   color: #065f46;
                   font-weight: 600;
                   background: rgba(16, 185, 129, 0.1);
                   padding: 0.5rem 1rem;
                   border-radius: 1rem;
                   display: inline-block;
               }

               .urgency-large {
                   animation: pulse 2s infinite;
               }

               /* ===== EMPTY STATE PREMIUM ===== */
               .empty-state-premium {
                   background: white;
                   border-radius: var(--border-radius-premium);
                   padding: 4rem 2rem;
                   box-shadow: var(--premium-shadow);
                   border: 1px solid #e5e7eb;
               }

               /* ===== ANIMATIONS ===== */
               @keyframes fadeInUp {
                   from {
                       opacity: 0;
                       transform: translateY(30px);
                   }
                   to {
                       opacity: 1;
                       transform: translateY(0);
                   }
               }

               /* ===== RESPONSIVE DESIGN PREMIUM ===== */
               @media (max-width: 768px) {
                   .modal-overlay {
                       padding: 10px;
                   }

                   .modal-container,
                   .modal-container-large {
                       max-width: 100%;
                   }

                   .modal-header-custom,
                   .modal-body-custom {
                       padding: 1.5rem;
                   }

                   .hero-section-premium {
                       padding: 2rem !important;
                       min-height: 300px;
                   }

                   .hero-title {
                       font-size: 2rem !important;
                   }

                   .hero-subtitle {
                       font-size: 1rem;
                   }

                   .stats-premium {
                       min-width: 100px;
                       padding: 1rem;
                   }

                   .course-card-premium:hover {
                       transform: none;
                   }

                   .course-overlay-premium {
                       opacity: 1;
                       background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 50%);
                   }

                   .course-image-premium {
                       height: 200px;
                   }

                   .course-title-premium {
                       font-size: 1.1rem !important;
                       min-height: auto;
                   }

                   .description-premium {
                       min-height: auto;
                   }

                   .instructor-section-premium {
                       padding: 0.75rem;
                   }

                   .cta-button-premium {
                       padding: 0.875rem 1.5rem;
                       font-size: 0.9rem;
                   }

                   .pricing-card-premium {
                       padding: 1rem;
                   }

                   .discounted-price-large,
                   .regular-price-large {
                       font-size: 2rem;
                   }

                   .course-info-card {
                       position: static;
                       margin-top: 2rem;
                   }
               }

               @media (max-width: 576px) {
                   .filters-premium .row {
                       gap: 1rem;
                   }

                   .hero-section-premium {
                       text-align: center;
                   }

                   .d-flex.gap-4 {
                       flex-direction: column;
                       gap: 1rem !important;
                   }

                   .discount-ribbon {
                       right: -25px;
                       padding: 0.4rem 2rem;
                   }

                   .ribbon-content {
                       font-size: 0.7rem;
                   }

                   .discount-percentage {
                       font-size: 0.9rem;
                   }

                   .z-index-10 {
                       z-index: 10;
                   }
               }

               /* ===== UTILITIES PREMIUM ===== */
               .bg-gradient-primary {
                   background: var(--primary-gradient) !important;
               }

               .text-gradient {
                   background: var(--primary-gradient);
                   -webkit-background-clip: text;
                   -webkit-text-fill-color: transparent;
                   background-clip: text;
               }

               /* ===== PERFORMANCE OPTIMIZATIONS ===== */
               .course-card-premium,
               .course-image-enhanced,
               .cta-button-premium,
               .stats-premium {
                   will-change: transform;
               }

               /* ===== ACCESIBILIDAD ===== */
               .btn:focus,
               .form-control:focus,
               .form-select:focus {
                   outline: 3px solid rgba(102, 126, 234, 0.5);
                   outline-offset: 2px;
               }

               /* ===== LOADING STATES ===== */
               .premium-input:disabled,
               .premium-select:disabled {
                   background-color: #f9fafb;
                   opacity: 0.7;
                   cursor: not-allowed;
               }

               .btn:disabled {
                   cursor: not-allowed;
                   opacity: 0.6;
               }

               /* ===== SCROLLBAR CUSTOM ===== */
               .modal-body-custom::-webkit-scrollbar {
                   width: 8px;
               }

               .modal-body-custom::-webkit-scrollbar-track {
                   background: #f1f1f1;
                   border-radius: 4px;
               }

               .modal-body-custom::-webkit-scrollbar-thumb {
                   background: var(--primary-gradient);
                   border-radius: 4px;
               }

               .modal-body-custom::-webkit-scrollbar-thumb:hover {
                   background: var(--primary-gradient);
               }
                   
/* ===== EMPRESA E INSTRUCTOR MEJORADO ===== */
.company-name {
    font-size: 0.85rem;
    font-weight: 600;
    color: #3b82f6 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    line-height: 1.2;
}

.instructor-label-name {
    font-size: 0.9rem;
    line-height: 1.3;
}

/* ===== FECHA DE INICIO LLAMATIVA ===== */
.start-date-section {
    margin-bottom: 1rem;
}

.start-date-banner {
    background: linear-gradient(135deg, #dbeafe, #bfdbfe);
    border: 2px solid #60a5fa;
    border-radius: 1rem;
    padding: 1rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    transition: var(--transition-premium);
}

.start-date-banner:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(96, 165, 250, 0.3);
}

.start-date-icon {
    width: 40px;
    height: 40px;
    background: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.start-date-content {
    flex-grow: 1;
}

.start-date-label {
    font-size: 0.8rem;
    color: #1e40af;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    line-height: 1;
}

.start-date-value {
    font-size: 1.1rem;
    color: #1e40af;
    font-weight: 700;
    line-height: 1.2;
    margin-top: 0.25rem;
}

/* ===== PRICING CARDS MEJORADO ===== */
.pricing-section-enhanced {
    border-radius: 1rem;
    overflow: hidden;
}

.pricing-card-discount {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border: 2px solid #e11d48;
    border-radius: 1rem;
    padding: 1rem;
    position: relative;
    box-shadow: 0 4px 20px rgba(225, 29, 72, 0.15);
}

.pricing-card-regular {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border: 2px solid #10b981;
    border-radius: 1rem;
    padding: 1rem;
    text-align: center;
    box-shadow: 0 4px 20px rgba(16, 185, 129, 0.15);
}

/* Discount Header */
.discount-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
}

.discount-badge-new {
    background: linear-gradient(135deg, #e11d48 0%, #f43f5e 100%);
    color: white;
    padding: 0.4rem 0.8rem;
    border-radius: 1.5rem;
    font-weight: 700;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    gap: 0.3rem;
    box-shadow: 0 3px 10px rgba(225, 29, 72, 0.3);
}

.discount-icon {
    font-size: 0.9rem;
}

.expiry-info {
    color: #6b7280;
    font-size: 0.7rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 0.2rem;
}

/* Price Comparison Mejorado */
.price-comparison-new {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.75rem;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    padding: 0.75rem;
    border-radius: 0.75rem;
    border: 1px solid #e2e8f0;
}

.price-before-section {
    text-align: center;
    flex: 1;
}

.price-after-section {
    text-align: center;
    flex: 1;
}

.price-label {
    display: block;
    font-size: 1rem;
    color: #6b7280;
    font-weight: 500;
    margin-bottom: 0.2rem;
}

.price-label-discount {
    display: block;
    font-size: 1rem;
    color: #059669;
    font-weight: 600;
    margin-bottom: 0.2rem;
}

.price-before-value {
    font-size: 1rem;
    color: #9ca3af;
    text-decoration: line-through;
    text-decoration-thickness: 2px;
    font-weight: 500;
}

.price-after-value {
    font-size: 1.4rem;
    color: #059669;
    font-weight: 700;
}

/* Savings */
.savings-highlight {
    background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
    padding: 0.5rem;
    border-radius: 0.75rem;
    text-align: center;
    font-weight: 600;
    color: #065f46;
    font-size: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    border: 1px solid #6ee7b7;
}

.savings-icon {
    font-size: 0.9rem;
}

/* Regular Pricing */
.price-regular-section {
    text-align: center;
}

.price-label-regular {
    display: block;
    font-size: 0.8rem;
    color: #6b7280;
    font-weight: 500;
    margin-bottom: 0.3rem;
}

.price-value-regular {
    font-size: 1.5rem;
    color: #059669;
    font-weight: 700;
}

/* ===== RESPONSIVE PRICING ===== */
@media (max-width: 768px) {
    .price-comparison-new {
        gap: 0.5rem;
        padding: 0.6rem;
    }
    
    .discount-header {
        flex-direction: column;
        gap: 0.5rem;
        text-align: center;
    }
    
    .price-after-value {
        font-size: 1.25rem;
    }
    
    .savings-highlight {
        font-size: 0.8rem;
        padding: 0.4rem;
    }
}

@media (max-width: 576px) {
    .start-date-banner {
        padding: 0.75rem;
        gap: 0.5rem;
    }
    
    .start-date-icon {
        width: 35px;
        height: 35px;
    }
    
    .start-date-value {
        font-size: 1rem;
    }
    
    .price-comparison-new {
        flex-direction: column;
        gap: 0.75rem;
        text-align: center;
    }
    
    .price-before-section,
    .price-after-section {
        flex: none;
    }
}
/* ===== LOGO DE EMPRESA ===== */
.company-logo {
    width: 48px;
    height: 48px;
    object-fit: contain;
    border-radius: 8px;
    background: white;
    padding: 4px;
    border: 2px solid #e5e7eb;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.company-logo-fallback {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #ddd6fe, #c4b5fd);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ===== DESCRIPCIÓN EXPANDIBLE ===== */
.description-section {
    position: relative;
}

.btn-link:focus {
    box-shadow: none;
}

.btn-link:hover {
    color: #5a67d8 !important;
}

/* ===== RESPONSIVE LOGOS ===== */
@media (max-width: 768px) {
    .company-logo,
    .company-logo-fallback {
        width: 40px;
        height: 40px;
    }
}     /* ===== DESCRIPCIÓN EXPANDIBLE MEJORADA ===== */
.description-toggle-btn {
    border-radius: 2rem;
    padding: 0.5rem 1.5rem;
    font-weight: 600;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    border: 2px solid #3b82f6;
    background: white;
    color: #3b82f6;
}

.description-toggle-btn:hover {
    background: #3b82f6;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

/* ===== SECCIÓN BROCHURE ===== */
.brochure-section {
    background: linear-gradient(135deg, #eff6ff, #dbeafe);
    border: 2px solid #60a5fa;
    border-radius: 1rem;
    padding: 1.5rem;
    text-align: center;
}

.brochure-link {
    border-radius: 2rem;
    padding: 0.75rem 2rem;
    font-weight: 600;
    font-size: 1rem;
    transition: all 0.3s ease;
    border: 2px solid #06b6d4;
    background: white;
    color: #06b6d4;
}

.brochure-link:hover {
    background: #06b6d4;
    color: white;
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(6, 182, 212, 0.4);
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
    .description-toggle-btn {
        font-size: 0.8rem;
        padding: 0.4rem 1.2rem;
    }
    
    .brochure-section {
        padding: 1rem;
    }
    
    .brochure-link {
        font-size: 0.9rem;
        padding: 0.6rem 1.5rem;
    }
}      `}</style>
       </div>
   );
};

export default CourseCatalog;